import React, { useState, useEffect, useContext } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import ReactSlider from 'react-slider';
import useProductCategory from '../../hooks/useProductCategory';
import useCompanyByAlphabetList from '../../hooks/useCompanyByAlphabetList';    
import { useAppConfig } from '../../context/AppConfigContext';
import { formatCurrency } from '../../constants';
import { Eye } from '@phosphor-icons/react';
import AlphabetPage from './AlphabetPage';

const Product = () => {
    const { config } = useAppConfig();
    const navigate = useNavigate();
    const currency = config?.currency === 'USD' ? '$' : config?.currency === 'AUD' ? 'AU$' : 'Rp';
    const {
        fetchProductCategory,
        data: productCategory,
        status: productCategoryStatus,
        error: productCategoryError
    } = useProductCategory();

    const {
        fetchCompanyByAlphabet,
        data: storeList,
        total: storeListTotal,
        status: storeListStatus,
        error: storeListError
    } = useCompanyByAlphabetList();

    const [searchParams, setSearchParams] = useSearchParams();
    const keyword = searchParams.get('category');
    const storeKeyword = searchParams.get('store');

    let [grid, setGrid] = useState(false);
    let [active, setActive] = useState(false);

    const [sortBy, setSortBy] = useState('name-asc');

    const [filterCategoryId, setFilterCategoryId] = useState(undefined);
    const [page, setPage] = useState(0);
    const [isLastPage, setIsLastPage] = useState(false);
    const [isFirstPage, setIsFirstPage] = useState(true);

    const [selectedLetter, setSelectedLetter] = useState('All');

    useEffect(() => {
        fetchProductCategory();
    }, []);

    useEffect(() => {
        if (keyword && productCategory.length > 0) {
            const categoryId = keyword !== 'all' ? productCategory.find((item) => item.slug === keyword)?.id : 'all';
            setFilterCategoryId(categoryId);
        }
    }, [keyword, productCategory]);

    useEffect(() => {
        if (filterCategoryId != undefined && filterCategoryId != null) {
            fetchCompanyByAlphabet({
                name: selectedLetter === "All" ? undefined : selectedLetter,
                categoryIds: filterCategoryId === 'all' ? undefined : filterCategoryId,
                sortBy: sortBy.split('-')[0],
                sortType: sortBy.split('-')[1],
                skip: page * 20,
                take: 20
            });
        } else if (keyword === null) {
            fetchCompanyByAlphabet({
                name: selectedLetter === "All" ? undefined : selectedLetter,
                categoryIds: undefined,
                sortBy: sortBy.split('-')[0],
                sortType: sortBy.split('-')[1],
                skip: page * 20,
                take: 20
            });
        }
    }, [filterCategoryId, page, sortBy, selectedLetter]);

    useEffect(() => {
        if (storeListStatus === 'done') {
            setIsLastPage(page + 1 === Math.ceil(storeListTotal / 20));
            setIsFirstPage(page === 0);
        }
    }, [storeListStatus]);

    const setAllCategory = () => {
        setFilterCategoryId(undefined);
        setPage(0);
    };

    const setSelectedGallery = (id) => {
        navigate('/product?category=' + id);
        // setFilterCategoryId(id);
        setPage(0);
    };

    let sidebarController = () => {
        setActive(!active);
    };

    return (
        <section className="shop py-40">
            <div className={`side-overlay ${active && 'show'}`}></div>
            <div className="container container-md">
                <div className="row">
                    {/* Sidebar Start */}
                    <div className="col-xxl-3 col-lg-3">
                        <div className={`shop-sidebar ${active && 'active'}`}>
                            <button
                                onClick={sidebarController}
                                type="button"
                                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-one-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-one-600"
                            >
                                <i className="ph ph-x" />
                            </button>
                            <div className="shop-sidebar__box border border-gray-100 rounded-8 p-20 mb-32">
                                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">Product Category</h6>
                                <ul className="max-h-540 overflow-y-auto scroll-sm">
                                    <li className={filterCategoryId === 'all' ? 'text-main-one-600 text-sm mb-10' : 'mb-16 text-sm'}>
                                        <Link
                                            to={`/products?category=all`}
                                            // onClick={() => setAllCategory()}
                                            className={
                                                filterCategoryId === 'all'
                                                    ? 'w-100 text-white text-sm bg-main-one-600 border border-gray-100 rounded-8 py-10 px-20'
                                                    : 'text-gray-900 hover-text-main-one-600'
                                            }
                                        >
                                            ALL CATEGORIES
                                        </Link>
                                    </li>
                                    {Array.isArray(productCategory) &&
                                        productCategory.length > 0 &&
                                        productCategory.map((item, index) => (
                                            <li
                                                className={
                                                    filterCategoryId === item.id ? 'text-main-one-600 text-sm mb-10' : 'mb-16 text-sm'
                                                }
                                                key={index}
                                            >
                                                <Link
                                                    to={`/products?category=${item.slug}`}
                                                    // onClick={() => setSelectedGallery(item.id)}
                                                    className={
                                                        filterCategoryId === item.id
                                                            ? 'w-100 text-white text-sm bg-main-one-600 border border-gray-100 rounded-8 py-10 px-20'
                                                            : 'text-gray-900 hover-text-main-one-600 text-sm'
                                                    }
                                                >
                                                    {item.name}
                                                </Link>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* Sidebar End */}
                    {/* Content Start */}

                    <div className="col-xxl-9 col-lg-9" style={{ position: 'relative' }}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#fff',
                                //backgroundColor: "rgba(0, 0, 0, 0.5)",
                                zIndex: '999',
                                display: storeListStatus === 'loading' ? 'block' : 'none'
                            }}
                        >
                            <img
                                src="assets/images/icon/preloader.gif"
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    left: '50%',
                                    marginTop: '100px',
                                    transform: 'translate(-50%, -50%)'
                                }}
                                alt=""
                            />
                        </div>
                        <div className="flex-between gap-16 flex-wrap mb-20 ">
                                    <span className="text-gray-900 text-md">
                                        Showing {page * 20 + 1}-{storeListTotal < 21 ? storeListTotal : (page + 1) * 20 < storeListTotal ? (page + 1) * 20 : storeListTotal} of {storeListTotal} result
                                    </span>
                                    <div className="position-relative flex-align gap-16 flex-wrap">
                                        {/* <div className="list-grid-btns flex-align gap-16">
                                            <button
                                                onClick={() => setGrid(true)}
                                                type="button"
                                                className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${
                                                    grid === true && 'border-main-600 text-white bg-main-one-600'
                                                }`}
                                            >
                                                <i className="ph-bold ph-list-dashes" />
                                            </button>
                                            <button
                                                onClick={() => setGrid(false)}
                                                type="button"
                                                className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${
                                                    grid === false && 'border-main-600 text-white bg-main-one-600'
                                                }`}
                                            >
                                                <i className="ph ph-squares-four" />
                                            </button>
                                        </div> */}
                                        <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                                            <label htmlFor="sorting" className="text-inherit flex-shrink-0">
                                                Sort by:{' '}
                                            </label>
                                            <select
                                                defaultValue={'name-asc'}
                                                className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                                                id="sorting"
                                                onChange={(e) => setSortBy(e.target.value)}
                                                style={{ minWidth: '130px' }}
                                            >
                                                <option value={'name-asc'}>Name A-Z</option>
                                                <option value={'name-desc'}>Name Z-A</option>
                                                {/* <option value={'price-asc'}>Lowest Price</option>
                                                <option value={'price-desc'}>Highest Price</option> */}
                                            </select>
                                        </div>
                                        <button
                                            onClick={sidebarController}
                                            type="button"
                                            className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                                        >
                                            <i className="ph-bold ph-funnel" />
                                        </button>
                                    </div>
                        </div>

                        <AlphabetPage data={storeList} selectedLetter={selectedLetter} setSelectedLetter={setSelectedLetter} storeListTotal={storeListTotal} isFirstPage={isFirstPage} isLastPage={isLastPage} page={page} setPage={setPage} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Product;
